import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { environment } from "../../../../../environments/environment";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-college-info-list",
  templateUrl: "./college-info-list.component.html",
  styleUrls: ["./college-info-list.component.scss"],
})
export class CollegeInfoListComponent implements OnInit {
  
  api = environment.apiUrl;
  colleges: any[] = [];
  page = 1;
  limit = 10;
  totalPages = 1;

  showCreateModal = false;
  form!: FormGroup;
  submitted = false;
  saving = false;

  businessTypes = ['College', 'Institute', 'University'];
  universities: any[] = [];

  constructor(
    private http: HttpClient,
    private router: Router,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.loadColleges();
    this.loadUniversities();
  }

  private getAuthConfig() {
    const token = localStorage.getItem("token")?.replace(/^"(.+)"$/, "$1");
    return {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Userinfo: JSON.stringify({
          _id: localStorage.getItem("adminSess"),
          role: localStorage.getItem("userRole"),
        }),
      },
    };
  }

  /** ---------------- FORM ---------------- */
  initForm() {
    this.form = this.fb.group({
      collegename: ['', Validators.required],
      businesstype: ['', Validators.required],
      university: ['', Validators.required],
      universityurl: [''],
      description: ['']
    });
  }

  get f() {
    return this.form.controls;
  }

  /** ---------------- LOAD COLLEGES ---------------- */
  loadColleges() {
    this.http.get<any>(`${this.api}/college`, {
      headers: this.getAuthConfig().headers,
      params: {
        page: String(this.page),
        limit: String(this.limit),
      }
    }).subscribe({
      next: (res) => {
        this.colleges = res?.results || [];
        this.totalPages = res?.totalPages || 1;
      },
      error: err => console.error("Failed to load colleges", err)
    });
  }

  /** ---------------- PAGINATION ---------------- */
  changePage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.page = page;
    this.loadColleges();
  }

  /** ---------------- STATUS TOGGLE ---------------- */
  toggleStatus(row: any) {
    const newStatus = row.status === 'Active' ? 'InActive' : 'Active';

    this.http.put(
      `${this.api}/college/${row._id}`,
      { status: newStatus },
      this.getAuthConfig()
    ).subscribe({
      next: () => {
        row.status = newStatus; // instant UI update
      },
      error: err => {
        console.error("Status update failed", err);
        alert("Failed to update status");
      }
    });
  }

  /** ---------------- ACTIONS ---------------- */
  editCollege(id: string) {
    this.router.navigate(['/college-details/college-form-list', id]);
  }

  viewCollege(id: string) {
    this.router.navigate(['/college-details/view-college-application', id]);
  }

  deleteRecord(row: any) {
    if (!confirm("Are you sure you want to delete this college?")) return;

    this.http.delete(`${this.api}/college/${row._id}`, this.getAuthConfig())
      .subscribe({
        next: () => {
          this.loadColleges();
          alert("Deleted successfully");
        },
        error: () => alert("Delete failed")
      });
  }

  /** ---------------- HELPERS ---------------- */
  truncate(text: string): string {
    return text?.length > 120 ? text.slice(0, 120) + '...' : text || '';
  }

  getCollegeLogo(path?: string): string {
    if (!path) return 'assets/images/placeholder-100.png';
    return path.startsWith('http') ? path : `${this.api}/${path}`;
  }

  loadUniversities() {
    this.http.get<any>(`${this.api}/university`).subscribe({
      next: res => this.universities = res?.results || [],
      error: () => this.universities = []
    });
  }
}

